var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "duration" }, [
    _c(
      "label",
      { attrs: { for: "duration-".concat(_vm.contractDuration.duration) } },
      [
        _c("input", {
          staticClass: "input-duration",
          attrs: {
            id: "duration-".concat(_vm.contractDuration.duration),
            type: "radio",
            name: "data[Order][durationDays]",
          },
          domProps: {
            value: _vm.contractDuration.duration,
            checked: _vm.selectedContractDuration === _vm.contractDuration,
          },
          on: {
            click: function ($event) {
              return _vm.$emit("contract-select", _vm.contractDuration)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "panel" },
          [
            _c(
              "strong",
              {
                staticClass: "panel__title",
                attrs: { "data-test-duration": _vm.contractDuration.duration },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.contractDuration.duration) +
                    "\n        " +
                    _vm._s(_vm.$t("general:non_special_texts.days")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.contractDuration.discount < 0
              ? [
                  _c("span", { staticClass: "panel__hint" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(Math.round(_vm.contractDuration.discount)) +
                        "%\n        "
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }